import { CarouselApi } from "@/components/ui/carousel";
import { cn, DEFAULT_HERO_IMAGE, isValidMediaUrl } from "@/lib/utils";
import Image from "next/image";

const ImageNavigation = ({
  index,
  currentIndex,
  carouselApi,
  imgSrc,
}: {
  index: number;
  currentIndex: number;
  carouselApi: CarouselApi;
  imgSrc: string;
}) => {
  const safeImgSrc = isValidMediaUrl(imgSrc) ? imgSrc.trim() : DEFAULT_HERO_IMAGE;

  return (
    <>
      <div
        onClick={(e) => {
          e.preventDefault();
          carouselApi?.scrollTo(index);
        }}
        className={cn(
          "relative hidden h-[28px] w-[52px] rounded-xs border-white md:block md:aspect-[61/7]",
          currentIndex === index
            ? "border-3 border-white bg-white"
            : "border border-gray-300"
        )}>
        <Image
          src={safeImgSrc}
          alt="carousel thumbnail"
          fill
          sizes="52px"
          priority
          className="rounded-xs object-cover"
        />
      </div>
      <div
        onClick={(e) => {
          e.preventDefault();
          carouselApi?.scrollTo(index);
        }}
        className={cn(
          "relative block h-2 w-2 rounded-full border-1 border-white md:hidden",
          currentIndex === index ? "bg-white" : "bg-transparent"
        )}
      />
    </>
  );
};

export default ImageNavigation;
